import React, { Component } from 'react';

import { throttle } from 'lodash'

import { getDistanceFromTop } from '../../utils/position.js'
import NavigationToggle from './NavigationToggle'
import Navigation from './Navigation'
import Logo from './Logo'

import { thresholds } from '../../constants/sizes.js'
import { getViewportSize } from '../../utils/screen.js'

class Header extends Component {


    constructor(props) {
        super(props)

        this.state = {
            isOpen: false,
            show: true,
            threshold: 100,
            top: 0
        }

        this.toggle = this.toggle.bind(this)
        this.scroll = this.scroll.bind(this)
        this.bind = this.bind.bind(this)
        this.removeBind = this.removeBind.bind(this)
        this.shouldShow = this.shouldShow.bind(this)
    }


    shouldShow(top){

        const oldTop = this.state.top
        const viewport = getViewportSize()

        if(viewport.width > thresholds.lg){
            return true
        }

        if(top < this.state.threshold){
            return true
        }
        
        if(top >= this.state.threshold && top > oldTop){
            return false
        }
        
        return true
    }


    scroll(e) {

        let top = getDistanceFromTop()
        let show = this.shouldShow(top)

        this.setState({
            show,
            isOpen: false,
            top
        });

    }


    toggle() {

        let isOpen = this.state.isOpen

        this.setState({
            isOpen: !isOpen
        })
    }

    componentDidMount() {

        this.cb = throttle(this.scroll);

        this.bind();
    }

    componentWillUnmount() {
        this.removeBind();
    }


    bind() {
        window.addEventListener('scroll', this.cb);
    }

    removeBind() {
        window.removeEventListener('scroll', this.cb);
    }


    render() {

        const { show, isOpen } = this.state

        return (
            <header>
                <Logo show={show} />
                <NavigationToggle isOpen={isOpen} toggle={this.toggle} show={show} />
                <Navigation toggle={this.toggle} isOpen={isOpen} show={show} {...this.props} />
                {/*<NavigationMask isOpen={this.state.isOpen} />*/}
            </header>
        );
    }
}

export default Header;